import { string } from 'prop-types';
import { useState } from 'react';
import {
  video1,
  video2,
  video3,
  pdf1,
  pdf2,
  pdf3,
  pdf4,
  pdf5,
  pdf6,
} from '@/assets/publicityFile';
import './index.less';

const videoArr = [
  { name: '视频1.mp4', url: video1 },
  { name: '视频2.mp4', url: video2 },
  { name: '视频3.mp4', url: video3 },
];

const pdfArr = [
  { name: '宣传手册.pdf', url: pdf1 },
  { name: '宣传手册-2.pdf', url: pdf2 },
  { name: '宣传折页.pdf', url: pdf3 },
  { name: '宣传折页-2.pdf', url: pdf4 },
  { name: '宣传海报.pdf', url: pdf5 },
  { name: '宣传画报.pdf', url: pdf6 },
];

export default function Detail({ type }) {
  const [active, setActive] = useState(0);
  const leftData = type === 'video' ? videoArr : pdfArr;
  const onChange = (i) => {
    setActive(i);
  };
  return (
    <div className="publicity-detail">
      <div className="publicity-detail__left">
        {
          leftData.map((item, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={index} className={`publicity-detail__left-item ${active === index && 'active'}`} onClick={() => onChange(index)}>{item.name}</div>
          ))
        }
      </div>
      <div className="publicity-detail__right">
        {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
        {type === 'video' ? (
          <video
            key={leftData[active].url}
            width="880"
            controls
            muted
            autoPlay
          >
            <source src={leftData[active].url} type="video/mp4" />
            您的浏览器不支持 video 标签。
          </video>
        ) : (
          <iframe
            src={leftData[active].url}
            width="880"
            height="500"
            title="PDF Viewer"
          />
        )}
      </div>
    </div>
  );
}
Detail.propTypes = {
  type: string,
};
